<template>
  <v-app id="bg"> 
    
    <v-container> 
      <v-row justify="center" v-if="isTimeCorrect"  class="centerTop">
        <v-col cols="5" offset-lg="1"  class="ma-1" >
          <base-material-card
            color="red"
            title="Page Not Found"
            class="px-8 py-3"
            icon="mdi-campfire"
            id="white"
          >
            <v-card-text class="px-0 pb-0 py-4">
              <v-sheet> 
                <br>
                <h1>404</h1>
                <br /> 
                <p>Sorry the page you were looking for does not exist.</p>
                <p>What should i do?</p>
                <br>
                <v-btn 
                  block
                  color="red"
                  :to="isLoggedIn?'/account/dashboard':'/'" 
                  >Go Back</v-btn
                >
                <br>
              </v-sheet>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
 
      <v-row justify="center" v-if="!isTimeCorrect"  class="centerTop">
        <v-col cols="5" class="ma-1" offset-lg="1">
          <base-material-card
            color="red"
            title="Invalid Time"
            class="px-12 py-3 my-12"
            icon="mdi-calendar-clock"
            id="white"
          >
            <v-card-text class="px-0 pb-0 py-4">
              <v-sheet> 
                <br>
                <h2>Adjust computer time.</h2>
                <br /> 
                <br>
                <p>Seems like your computer time is off.</p>
                <p>Try adjusting your computer time and try again.</p>
                <br>
              </v-sheet>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>

    </v-container> 
  </v-app>
</template>

<script>
import { mapGetters,mapState } from "vuex"; 
import moment from 'moment';

export default {
  name: "settings", 
  computed: {  
    ...mapGetters(['isLoggedIn']), //,'isTimeCorrect'
  },

  data() {
    return { 
      isTimeCorrect: true
    }
  },

  methods: {
  }
};
</script>

<style scoped>
#bg{
  width: 100%;
  background: #dddddd;
}

.centerTop{
  margin-top: 8% !important
}
</style>
